<template>
  <ClientOnly>
    <VNavigationDrawer v-model="link.themeDrawer" floating order="-1" width="280" elevation="0" color="transparent"
      location="right" temporary>
      <VCard class="pb-2" :style="backgroundStyle" rounded="0" flat height="100%">
        <VToolbar color="transparent">
          <template #title>
            <span class="font-weight-medium">
              Theme Editor
            </span>
          </template>
          <template v-slot:append>
            <VBtn variant="flat" icon="$mdiClose" @click="link.themeDrawer = false" aria-label="Close theme drawer" />
          </template>
        </VToolbar>

        <div class="px-4">
          <AppSettingsTheme />

          <template v-if="route.path.includes('/auth') || route.meta.layout === 'secure'">
            <FontPicker />
          </template>

          <template v-if="route.meta.layout !== 'default'">
            <VListSubheader>Sensitivity Mode</VListSubheader>
            <VBtn class="mb-2" block :color="store.sensitivityMode ? 'green' : 'red-darken-4'"
              @click="store.sensitivityMode = !store.sensitivityMode" flat>
              {{ store.sensitivityMode ? "Enabled" : "Disabled" }}
            </VBtn>

            <VListSubheader>Layout</VListSubheader>
            <VBtn class="mb-2" block color="primary" @click="layout" flat>
              {{ store.layoutVertical ? "Vertical" : "Horizontal" }}
            </VBtn>
          </template>


          <template v-if="devMode">
            <VListSubheader>Debug</VListSubheader>

            <VBtn v-model="store.debugging" block @click="store.debugging = !store.debugging"
              :color="store.debugging === true ? 'green' : 'red-darken-4'" flat>
              <VIcon class="mr-2" icon="$mdiBug" size="large" />
              Debug: {{ store.debugging === true ? 'ON' : 'OFF' }}
            </VBtn>
          </template>
        </div>

      </VCard>
    </VNavigationDrawer>
  </ClientOnly>
</template>

<script setup>
import { useAppLink } from '@S/appLink';
import { useAppStore } from '@S/appStore';
import AppSettingsTheme from './Theme.vue';
import { useRoute } from 'vue-router';
import { useTheme } from 'vuetify';

let link = useAppLink();
let store = useAppStore();
const route = useRoute();
const theme = useTheme();

const devMode = ref(import.meta.env.DEV)



function layout() {
  store.layoutVertical = !store.layoutVertical;
  if (store.layoutVertical === false) {
    link.secureMainDrawer = false;
  };
  if (store.layoutVertical === true) {
    link.secureMainDrawer = true;
  };
}

const backgroundStyle = computed(() => {
  return `background-color: rgba(${theme.global.name.value === 'light' ? '255, 255, 255' : '16, 16, 16'}, ${store.deviceType === 'Desktop' ? theme.global.name.value === 'light' ? .95 : .8 : 1});
        transition: background-color .15s ease, backdrop-filter .15s ease;
        ${store.deviceType === 'Desktop' ? 'backdrop-filter: blur(5px) saturate(250%); box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);' : ''}`;
});
</script>